
import React from 'react'
import classnames from 'classnames'

import { useThemeContext } from '../../contexts/ThemeProvider'
import ContextMenuTitleAction from './Actions/ContextMenuTitleAction'

const PageTitleContextMenu = ({ heading, subheading, icon, headerOptions }) =>
{
	const [controller, dispatch] = useThemeContext()
	const { enablePageTitleIcon, enablePageTitleSubheading } = controller
	
	return (
		<div className="app-page-title">
			<div className="page-title-wrapper">
				<div className="page-title-heading">
					<div className={ classnames("page-title-icon", { "d-none": !enablePageTitleIcon, }) }>
						<i className={ icon } />
					</div>
					<div>
						{ heading }
						<div className={ classnames("page-title-subheading", { "d-none": !enablePageTitleSubheading, }) }>
							{ subheading }
						</div>
					</div>
				</div>
				<div className="page-title-actions">{ <ContextMenuTitleAction headerOptions={ headerOptions } /> }</div>
			</div>
		</div>
	)
}

export default PageTitleContextMenu
